module.exports = "/_next/static/images/00a84e26aa5ca960a8d11d27a7c492f2-mb-hero-lg.jpg.webp";